import React from 'react';

export default function CTAButton({ lang }) {
  return (
    <a 
      href="#" 
      className="block w-full text-center bg-amber-400 text-black font-black text-2xl sm:text-3xl py-5 px-4 border-4 border-white shadow-[6px_6px_0_0_#ffffff] hover:translate-y-1 hover:translate-x-1 hover:shadow-[0px_0px_0_0_#ffffff] transition-all uppercase"
    >
      {lang === 'en' ? 'Get The Pass Now' : 'Obtén El Pase Ahora'}
    </a>
  );
}